/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserWithLinks } from '../models/user-with-links';
@Injectable({
  providedIn: 'root',
})
class MeWithLinksService extends __BaseService {
  static readonly MeWithLinksGetPath = '/me-with-links';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the current user with links
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  MeWithLinksGetResponse(Authorization: string): __Observable<__StrictHttpResponse<UserWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/me-with-links`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserWithLinks>;
      })
    );
  }
  /**
   * Returns the current user with links
   * @param Authorization Bearer JSON Web Token
   * @return OK
   */
  MeWithLinksGet(Authorization: string): __Observable<UserWithLinks> {
    return this.MeWithLinksGetResponse(Authorization).pipe(
      __map(_r => _r.body as UserWithLinks)
    );
  }
}

namespace MeWithLinksService {
}

export { MeWithLinksService }